<template>
    <div class="all-height">
        <el-main class="all-height">
            <div style="position: relative;margin-bottom: 5px;">
                <el-button plain>同意提交</el-button>
                <el-button plain>修改退回</el-button>
                <el-button plain style="margin-right: 50px">备注</el-button>
                <el-button plain>暂存保存</el-button>
                <el-button plain>签章预览</el-button>
                <el-button plain>查看图纸</el-button>
                <el-button plain>订单明细</el-button>
                <div style="position: absolute;right: 0;top: 0;">
                    <el-form :inline="true">
                        <el-form-item>
                        </el-form-item>
                        <el-form-item label="选择供应商">
                            <el-input placeholder="请选择供应商" size="mini" readonly clearable></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-input size="mini" placeholder="请输入用户名称或账号" clearable/>
                        </el-form-item>
                        <el-form-item>
                            <el-button icon="el-icon-search" circle style="float: right" ></el-button>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
            <div class="table-box">
                <el-table :data="orderInfoData" height="calc(100% - 55px)"
                          :header-cell-style="{background:'#4885CA', color: 'white'}">
                    <el-table-column type="selection" width="55" align="center" header-align="center">
                    </el-table-column>
                    <el-table-column property="date" label="状态" align="center" header-align="center">
                    </el-table-column>
                    <el-table-column property="date" label="供应商编码" align="center" header-align="center">
                    </el-table-column>
                    <el-table-column property="date" label="供应商编码" align="center" header-align="center">
                    </el-table-column>
                    <el-table-column property="date" label="下发时间" align="center" header-align="center">
                    </el-table-column>
                    <el-table-column property="date" label="问卷文件" align="center" header-align="center">
                    </el-table-column>
                    <el-table-column property="date" label="下载" align="center" header-align="center">
                    </el-table-column>
                    <el-table-column property="date" label="完成时间" align="center" header-align="center">
                    </el-table-column>
                    <el-table-column property="date" label="交卷问卷" align="center" header-align="center">
                    </el-table-column>
                    <el-table-column property="date" label="提交问卷下载" align="center" header-align="center">
                    </el-table-column>
                    <el-table-column property="date" label="备注" align="center" header-align="center">
                    </el-table-column>
                </el-table>
                <div class="table-page">
                    <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="current"
                            :page-sizes="[100, 200, 300, 400]"
                            :page-size="100"
                            layout="total, sizes, prev, pager, next, jumper"
                            :total="400">
                    </el-pagination>
                </div>
            </div>
        </el-main>
    </div>
</template>
<script>
    export default {
        name: 'questionnaire',
        data() {
            return {
                current: 1,
                orderInfoData: [
                    {orderNo: 'WH213',company: '卫华集团', address: '河南新乡', date: '2020-07-13'},
                    {orderNo: 'WH213',company: '卫华集团', address: '河南新乡', date: '2020-07-13'},
                    {orderNo: 'WH213',company: '卫华集团', address: '河南新乡', date: '2020-07-13'},
                    {orderNo: 'WH213',company: '卫华集团', address: '河南新乡', date: '2020-07-13'},
                    {orderNo: 'WH213',company: '卫华集团', address: '河南新乡', date: '2020-07-13'},
                    {orderNo: 'WH213',company: '卫华集团', address: '河南新乡', date: '2020-07-13'},
                    {orderNo: 'WH213',company: '卫华集团', address: '河南新乡', date: '2020-07-13'},
                    {orderNo: 'WH213',company: '卫华集团', address: '河南新乡', date: '2020-07-13'},
                    {orderNo: 'WH213',company: '卫华集团', address: '河南新乡', date: '2020-07-13'},
                    {orderNo: 'WH213',company: '卫华集团', address: '河南新乡', date: '2020-07-13'},
                    {orderNo: 'WH213',company: '卫华集团', address: '河南新乡', date: '2020-07-13'},
                    {orderNo: 'WH213',company: '卫华集团', address: '河南新乡', date: '2020-07-13'},
                    {orderNo: 'WH213',company: '卫华集团', address: '河南新乡', date: '2020-07-13'},
                    {orderNo: 'WH213',company: '卫华集团', address: '河南新乡', date: '2020-07-13'},
                    {orderNo: 'WH213',company: '卫华集团', address: '河南新乡', date: '2020-07-13'},
                    {orderNo: 'WH213',company: '卫华集团', address: '河南新乡', date: '2020-07-13'},
                    {orderNo: 'WH213',company: '卫华集团', address: '河南新乡', date: '2020-07-13'},
                    {orderNo: 'WH213',company: '卫华集团', address: '河南新乡', date: '2020-07-13'},
                    {orderNo: 'WH213',company: '卫华集团', address: '河南新乡', date: '2020-07-13'},
                ]
            };
        },
        methods: {
            handleSizeChange() {
            },
            handleCurrentChange() {
            }
        }
    }
</script>
<style scoped>
    .table-box {
        position: relative;
        margin-top: 5px;
        background-color: white;
        height: calc(100% - 45px);
        width: 100%;
    }
    .table-page {
        width: 100%;
        text-align: center;
        position: absolute;
        bottom: 10px;
    }
</style>